import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { App } from './app';
import { createQueryClient } from './api/query';
import { restoreTheme } from '@/lib/theme';
import { AppToaster } from '@/components/AppToaster';
// Manrope, only the three subsets Vietnamese text is drawn from (latin, latin-ext for ă/đ/ơ/ư, vietnamese for
// the stacked tones). Served as files from `dist/assets` — `font-src 'self'` refuses a `data:` font, which is
// why vite.config.ts never inlines one.
import '@fontsource/manrope/latin-400.css';
import '@fontsource/manrope/latin-500.css';
import '@fontsource/manrope/latin-600.css';
import '@fontsource/manrope/latin-700.css';
import '@fontsource/manrope/latin-ext-400.css';
import '@fontsource/manrope/latin-ext-500.css';
import '@fontsource/manrope/latin-ext-600.css';
import '@fontsource/manrope/latin-ext-700.css';
import '@fontsource/manrope/vietnamese-400.css';
import '@fontsource/manrope/vietnamese-500.css';
import '@fontsource/manrope/vietnamese-600.css';
import '@fontsource/manrope/vietnamese-700.css';
// Order is the cascade: the locked design language, this product's tokens on top, then styles.css (the touch
// floor and the element defaults).
import './styles/globals.css';
import './styles/app-tokens.css';
import './styles/motion.css';
import './styles.css';
// The toast stack: sonner's own rules as a file (production's `style-src 'self'` refuses the <style> sonner writes at
// runtime), then the product's look on top.
import 'sonner/dist/styles.css';
import './styles/toast.css';

/** The browser entry point. The client's rules (no retry, a 403 re-reads the principal) live in `createQueryClient`. */
const queryClient = createQueryClient();

// The chosen accent is on <html> before the first paint, so a saved theme never flashes the default blue.
restoreTheme();

const container = document.getElementById('root');
if (!container) throw new Error('Không tìm thấy phần tử #root để khởi động ứng dụng.');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {/* The one toast stack, on every page; before the routes so it hears a page's first word. */}
        <AppToaster />
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
